import StorageImage from "./StorageImage";

function isImageFile(file) {
  const contentType = String(file?.contentType || "").toLowerCase();
  const name = String(file?.name || file?.fullPath || "").toLowerCase();

  return (
    contentType.startsWith("image/") ||
    name.endsWith(".png") ||
    name.endsWith(".jpg") ||
    name.endsWith(".jpeg") ||
    name.endsWith(".webp") ||
    name.endsWith(".gif") ||
    name.endsWith(".svg")
  );
}

function StoragePreview({ file, enabled }) {
  if (!enabled) {
    return (
      <div className="storage-file-preview-placeholder" title="Preview desactivada">
        <span>📟</span>
        <small>Preview off</small>
      </div>
    );
  }

  if (!isImageFile(file)) {
    return (
      <div
        className="storage-file-preview-placeholder"
        title={file?.contentType || "Archivo"}
      >
        <span>📄</span>
        <small>No es imagen</small>
      </div>
    );
  }

  return (
    <StorageImage
      path={file.fullPath}
      version={file.updated || ""}
      alt={file.name || "Preview"}
      className="storage-file-image"
      fallback="🖼️"
      enabled={enabled}
    />
  );
}

export default StoragePreview;